import { Box, styled, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'


const Icon=styled(Box)(
{
    width:"10%",
    height:"12%",
    backgroundColor:"white",
    borderRadius:"10px",
    position:"absolute",
}
)


function Image({position}) 
{
    const iconRefs = useRef([React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef(),React.createRef()]);
  
    const [positions, setPositions] = useState([{ top: 0, left: 0 },{ top: 0, left: 0 },{ top: 0, left: 0 },{ top: 0, left: 0 },{ top: 0, left: 0 },{ top: 0, left: 0 }]);
  
    const getIconsPosition = () => {
      const newPositions = iconRefs.current.map((iconRef) => {
        if (iconRef.current) {
          const rect = iconRef.current.getBoundingClientRect();
          return { top: rect.top, left: rect.left };
        }
        return { top: 0, left: 0 };
      });
      setPositions(newPositions);

    };
    useEffect(()=>
    {
        getIconsPosition();
    },[position])
    
  return (
    <>
       <Box sx={{position:"relative"}}  >
            <Box sx={{display:"flex",justifyContent:'center',zIndex:"-999",}} >
                <img 
                    src='./images/myImage4.png' 
                    style={{
                        
                        width:"70%",
                        height:"auto",
                        transition:"filter 0.5s ease-out",
                        mixBlendMode: 'multiply',
                        transform:"scale(0.9) translateY(0px)"
                    }}
                    alt='My picture'
                />
            </Box>
            <img src='./images/bg1.png' style={{position:"absolute",top:"-10px",left:"10%",width:"80%",zIndex:"-1",mixBlendMode: 'lighten'}} alt='bg image'/>
            <Icon ref={iconRefs.current[0]}
                sx={{
                    top:"0px",
                    left:"0px",
                    transform:(position.x || position.y)?`translate(${(position.x-positions[0].left)/20}px,${(position.y-positions[0].top)/20}px)`:"",
                    // zIndex:"-1",
                    transition:"transform 0.5s ease-out",opacity:0.7
                }} 
            >
                <img src='./images/icons/react.png' style={{width:"100%",height:"100%"}} alt='icon'/>
            </Icon>
            <Icon ref={iconRefs.current[1]}
                sx={{
                    right:"0px",
                    top:"0px",
                    transform:(position.x || position.y)?`translate(${(position.x-positions[1].left)/20}px,${(position.y-positions[1].top)/20}px)`:"",
                    // zIndex:"-1",
                    transition:"transform 0.5s ease-out ",opacity:0.7

                }} 
            >
                <img src='./images/icons/node.png'  style={{width:"100%",height:"100%"}} alt='icon'/>
            </Icon>
            <Icon ref={iconRefs.current[2]}
                sx={{
                    top:"45%",
                    left:"10%",
                    transform:(position.x || position.y)?`translate(${(position.x-positions[2].left)/20}px,${(position.y-positions[2].top)/20}px)`:"",
                    // zIndex:"-1",
                    transition:"transform 0.5s ease-out ",opacity:0.7

                }} 
            >
                <img src='./images/icons/mongoDb.png'  style={{width:"100%",height:"100%"}} alt='icon'/>
            </Icon>
            <Icon ref={iconRefs.current[3]}
                sx={{
                   right:"10%",
                   top:"45%",
                   transform:(position.x || position.y)?`translate(${(position.x-positions[3].left)/20}px,${(position.y-positions[3].top)/20}px)`:"",
                    // zIndex:"-1",
                    transition:"transform 0.5s ease-out",opacity:0.7

                }} 
            >
                <img src='./images/icons/java.png'  style={{width:"100%",height:"100%"}} alt='icon'/>
            </Icon>
            <Icon ref={iconRefs.current[4]}
                sx={{
                    bottom:"0px",
                    left:"0px",
                    transform:(position.x || position.y)?`translate(${(position.x-positions[4].left)/20}px,${(position.y-positions[4].top)/20}px)`:"",
                    // zIndex:"-1",
                    transition:"transform 0.5s ease-out ",opacity:0.7

                }}  
            >
                <img src='./images/icons/js.png'  style={{width:"100%",height:"100%"}} alt='icon'/>
            </Icon>

            <Icon ref={iconRefs.current[5]}
                sx={{
                    right:"0px",
                    bottom:"0px",
                    transform:(position.x || position.y)?`translate(${(position.x-positions[5].left)/20}px,${(position.y-positions[5].top)/20}px)`:"",
                    // zIndex:"-1",
                    transition:"transform 0.5s ease-out ",opacity:0.7

                }}  
            >
                <img src='./images/icons/express.png'  style={{width:"100%",height:"100%"}} alt='icon'/>
            </Icon>
            
       </Box>
    </>
  )
}

export default Image